import React from 'react';
import { useSelectedTheme } from '../../../../../../Hooks';
import useStyles from '../styles';
import Divider from '../Divider';
import { CustomInput } from '../../../../../../Components';

function CPP_BI_FinancialInformation({
  translate,
  selected,
  setSelected,
  handleSelectedChange,
}) {
  const styles = useStyles();
  const {
    theme: { palette },
  } = useSelectedTheme();
  return (
    <>
      <div className={styles.CPP_BI_FinancialInformationSectionWrapper}>
        <div>
          <div style={{ paddingBottom: '16px' }}>
            <span className={styles.CPP_BI_FinancialInformationSectionTitle}>
              {translate('financial-information')}
            </span>
          </div>
          <Divider />
          <div className={styles.CPP_itemWrapper}>
            <span className={styles.CPP_fieldLabel}>
              {translate('service-charge')}
            </span>
            <div className={styles.CPP_fieldWrapper}>
              <CustomInput
                placeholder={translate('enter')}
                hasSearchIcon={false}
                style={{ minWidth: '100%' }}
                value={selected.serviceCharge}
                type='number'
                onChange={(e) => {
                  const value = +e.target.value || null;
                  handleSelectedChange('serviceCharge', value);
                }}
              />
            </div>
          </div>
          <Divider />
          <div className={styles.CPP_itemWrapper}>
            <span className={styles.CPP_fieldLabel}>
              {translate('expected-ROI')} %
            </span>
            <div className={styles.CPP_fieldWrapper}>
              <CustomInput
                placeholder={translate('enter')}
                hasSearchIcon={false}
                style={{ minWidth: '100%' }}
                value={selected.expectedROI}
                type='number'
                startAdornment={<span>%</span>}
                onChange={(e) => {
                  const value = +e.target.value || null;
                  handleSelectedChange('expectedROI', value);
                }}
              />
            </div>
          </div>
          <Divider />
          <div className={styles.CPP_itemWrapper}>
            <span className={styles.CPP_fieldLabel}>
              {translate('security-deposit')} %
            </span>
            <div className={styles.CPP_fieldWrapper}>
              <CustomInput
                placeholder={translate('enter')}
                hasSearchIcon={false}
                style={{ minWidth: '100%' }}
                value={selected.securityDeposit}
                type='number'
                onChange={(e) => {
                  const value = +e.target.value || null;
                  handleSelectedChange('securityDeposit', value);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CPP_BI_FinancialInformation;
